import React, { useMemo } from 'react';
import Anchor from './Anchor';
import AntdAnchor from './AntdAnchor';
import AntdAnchorLink from './AntdAnchorLink';
import AnchorHorizontal from './AnchorHorizontal';
import { EntranceProps, AnchorLinkProps } from './iAnchor';

// 定义带有静态属性的组件类型
interface AnchorWrapperComponent extends React.FC<EntranceProps> {
    Link: React.FC<AnchorLinkProps>;
}

const AnchorWrapper: React.FC<EntranceProps> = (props) => {
    const { antd, children, direction, activeKey, getCurrentAnchor, ...other } = props;

    // 使用 useMemo 缓存计算的 activeKey
    const computedActiveKey = useMemo(() => {
        return activeKey || (getCurrentAnchor ? getCurrentAnchor() : '');
    }, [activeKey, getCurrentAnchor]);

    const disableProps = useMemo(() => ({
        activeKey: computedActiveKey
    }), [computedActiveKey]);

    // 根据不同模式渲染对应组件
    if (direction === 'horizontal') {
        return (
            <AnchorHorizontal {...other} {...disableProps}>
                {children}
            </AnchorHorizontal>
        );
    }

    if (antd) {
        return (
            <AntdAnchor {...other} {...disableProps}>
                {children}
            </AntdAnchor>
        );
    }

    return (
        <Anchor {...other}>
            {children}
        </Anchor>
    );
};

// 添加静态属性
const AnchorWithLink = AnchorWrapper as AnchorWrapperComponent;
AnchorWithLink.Link = AntdAnchorLink;

export default AnchorWithLink;
